<template>
    <div class="components-filter-view-config-region-select-container">
        <v-popconfirm
            ref="chosen"
            placement="bottom-start"
            :fixed="false"
            :use-arrow="false"
            :inline="inline"
            clazz="popper-filter-view-config-region-select-container"
            :confirm-disabled="false && needDisable"
            :loading="!ready"
            @confirm="handleConfirm"
            @cancel="handleCancel"
            @visibleChange="handleVisibleChange"
        >
            <div
                v-if="startRender"
                v-spinner="!ready"
                class="location-select-new-container"
            >
                <v-spinner size="large" />
                <!-- 国家 -->
                <ul
                    v-if="ready && !useCustom"
                    class="location-select-list-new country"
                >
                    <li
                        v-for="(country, cIdx) in countryLocations"
                        :key="`country${cIdx}`"
                        :title="country.name"
                        @mouseover="hoverCountry(country, cIdx)"
                    >
                        <v-checkbox
                            :key="cIdx"
                            v-model="selectedStatus[cIdx].checked"
                            :label="country.name"
                            :value="country.value"
                            :indeterminate="selectedStatus[cIdx].indeterminate"
                            :class="['checkbox-content', hoverCountryIndex == cIdx ? 'hover-province' : '']"
                            @change="event => selectCountry(event, country)"
                        >
                            {{ country.name }}
                        </v-checkbox>
                        <v-icon
                            v-show="country.subs && country.subs.length"
                            name="v-arrow_dropdown"
                            :rotate="-90"
                            flip="horizontal"
                            class="location-arrow-icon"
                        />
                    </li>
                </ul>

                <!-- 省 -->
                <ul
                    v-if="ready"
                    class="location-select-list-new province"
                    :class="{ 'no-country': useCustom }"
                >
                    <li
                        v-for="(province, pIdx) in provinceLocations"
                        :key="`province${pIdx}`"
                        :title="province.name"
                        @mouseover="hoverProvince(province, pIdx)"
                    >
                        <v-checkbox
                            :key="pIdx"
                            v-model="selectedStatus[hoverCountryIndex].province[pIdx].checked"
                            :label="province.name"
                            :value="province.value"
                            :indeterminate="selectedStatus[hoverCountryIndex].province[pIdx].indeterminate"
                            :class="['checkbox-content', hoverProvinceIndex == pIdx ? 'hover-province' : '']"
                            @change="event => selectProvince(event, province)"
                        >
                            {{ province.name }}
                        </v-checkbox>
                        <v-icon
                            v-show="province && province.subs && province.subs.length"
                            name="v-arrow_dropdown"
                            :rotate="-90"
                            flip="horizontal"
                            class="location-arrow-icon"
                        />
                    </li>
                </ul>

                <!-- 市 -->
                <ul
                    v-if="ready"
                    class="location-select-list-new city"
                    :class="{ 'no-country': useCustom }"
                >
                    <li
                        v-for="(region, rIdx) in cityLocations"
                        :key="`city${rIdx}`"
                        :title="region.name"
                        @mouseover="hoverCity(region, rIdx)"
                    >
                        <v-checkbox
                            :key="rIdx"
                            v-model="selectedStatus[hoverCountryIndex].province[hoverProvinceIndex].city[rIdx].checked"
                            :label="region.name"
                            :value="region.value"
                            :indeterminate="
                                selectedStatus[hoverCountryIndex].province[hoverProvinceIndex].city[rIdx].indeterminate
                            "
                            :class="['checkbox-content', hoverCityIndex == rIdx ? 'hover-province' : '']"
                            @change="event => selectCity(event, region)"
                        >
                            {{ region.name }}
                        </v-checkbox>
                    </li>
                </ul>
                <div
                    v-if="!useCustom"
                    class="batch-operation-container"
                >
                    <span
                        class="batch-select"
                        @click="handleSelectAll"
                    >全选</span><span
                        class="batch-unselect"
                        @click="handleClearAll"
                    >清空</span>
                </div>
            </div>
            <template slot="confirm-text">
                确定 <span v-show="!needDisable">({{ currentValueLength }})</span>
            </template>
        </v-popconfirm>

        <div v-popconfirm:chosen>
            <div class="location-select-header-wrapper">
                <slot
                    name="header"
                    :regionNames="currentRegionName"
                >
                    <div class="location-select-header">
                        <span>{{ currentText }}</span>
                    </div>
                </slot>
                <v-icon
                    class="select-icon"
                    name="arrow_dropdown"
                />
            </div>
        </div>
    </div>
</template>

<script>
/* eslint-disable */
import { loadResource } from '@tencent/qd-lib';
import raf from 'src/utils/raf';

export default {
    name: 'RegionSelector',
    props: {
        locations: {
            type: Array,
            default() {
                return [];
            }
        },
        inline: {
            type: Boolean,
            default: false
        },
        useCustom: Boolean,
        value: [Array, String, Object],
        immediateRender: {
            // 是否立即加载; 由于放在主页面一起加载在IE环境太卡，这里默认使用懒加载
            type: Boolean,
            default: false
        },
        polymerization: Boolean // 是否聚合
    },
    data() {
        const tmpValue = this.createValueTree(this.value) || [];
        return {
            currentText: '',
            currentLocations: this.locations && this.locations.length ? this.locations.concat() : [],
            hoverCountryIndex: 0,
            hoverProvinceIndex: 0,
            hoverCityIndex: 0,
            countryLocations: [],
            selectedStatus: [], // 每一项的选择状态
            currentValue: JSON.parse(JSON.stringify(tmpValue)),
            oldValue: JSON.parse(JSON.stringify(tmpValue)),
            currentPolyValue: [], // 聚合的值
            oldPolyValue: [],
            currentRegion: [],
            polyRegion: [],
            ready: false,
            startRender: false
        };
    },
    computed: {
        provinceLocations() {
            return this.currentLocations[this.hoverCountryIndex]
                ? this.currentLocations[this.hoverCountryIndex].subs
                : [];
        },
        cityLocations() {
            return this.currentLocations[this.hoverCountryIndex] &&
                this.currentLocations[this.hoverCountryIndex].subs[this.hoverProvinceIndex]
                ? this.currentLocations[this.hoverCountryIndex].subs[this.hoverProvinceIndex].subs
                : [];
        },
        needDisable() {
            return !Object.keys(this.currentValue).length;
        },
        currentRegionName() {
            return this.currentRegion.map(region => region.name);
        },
        currentValueLength() {
            /**
             * 组件需要实时统计currentValue的长度，由于currentValue是一个树结构，因此只能选用响应式的结构进行层层统计，
             * 来计算叶节点的数量。
             */
            let nodeList = [this.currentValue];
            let tmpList = [];
            let count = 0;
            while (nodeList.length > 0) {
                tmpList = [];
                for (const node of nodeList) {
                    const keys = Object.keys(node);
                    if (keys.length === 0) count += 1;
                    else {
                        for (const key of keys) {
                            tmpList.push(node[key]);
                        }
                    }
                }
                nodeList = tmpList.concat();
            }
            return count;
        }
    },
    watch: {
        locations(val) {
            this.currentLocations = val.concat();
            this.initOptions();
        },
        value(val) {
            console.log('value change', val);
            let newValue = this.createValueTree(val);
            if(JSON.stringify(this.currentValue) === JSON.stringify(newValue)) {
                return false;
            }
            this.currentValue = this.createValueTree(val);
            this.oldValue = JSON.parse(JSON.stringify(this.currentValue));

            this.initOptions();
            this.synStatus();
            this.polymerization && this.getPolyInfo();
        },
        currentValue(val) {
            const res = this.polymerization ? this.currentPolyValue.map(item => item.split('@')) : this.treeToVal(val);
            this.$emit('change', res);
        },
        startRender(newValue) {
            console.log('startRender');
            /**
             * 用于懒加载，当startRender被第一次设为true时，触发初始化
             */
            if (newValue) {
                this.ready = false;
                this.delayInitions();
                this.$emit('startRenderComplete');
            }
        }
    },
    created() {
        if (this.useCustom) {
            this.currentLocations = JSON.parse(JSON.stringify(this.locations));
            if (this.immediateRender) this.startRender = true;
        } else if (window.__QIAIN_COM_LOCATIONS && !this.useCustom) {
            this.currentLocations = JSON.parse(JSON.stringify(window.__QIAIN_COM_LOCATIONS));
            if (this.immediateRender) this.startRender = true;
        } else {
            loadResource('https://bqq.gtimg.com/vea//static/direct/regionData.js', () => {
                this.currentLocations = JSON.parse(JSON.stringify(window.__QIAIN_COM_LOCATIONS));
                if (this.immediateRender) this.startRender = true;
            });
        }
    },
    methods: {
        delayInitions() {
            console.log('delayInitions')
            /**
             * 利用raf将数据的初始化做一个分割，防止生成新的组件时数据初始化造成页面卡顿
             */
            raf(() => {
                this.initOptions();
                raf(() => {
                    console.log('ani');
                    this.synStatus();
                    this.ready = true;
                });
            });
        },
        initOptions() {
            /**
             * 生成选项勾选状态标志位，生成初始的国家选项
             */
            this.selectedStatus = [];

            this.currentLocations.map((country, cIdx) => {
                this.selectedStatus.push({
                    checked: false,
                    indeterminate: false,
                    province: []
                });
                country.subs.map((province, pIdx) => {
                    this.selectedStatus[cIdx].province.push({
                        checked: false,
                        indeterminate: false,
                        city: []
                    });
                    province.subs.map(city => {
                        this.selectedStatus[cIdx].province[pIdx].city.push({
                            checked: false,
                            indeterminate: false
                        });
                    });
                });
            });
            this.countryLocations = this.currentLocations.map(country => {
                return {
                    name: country.name,
                    value: country.value,
                    subs: country.subs || []
                };
            });
        },
        synStatus() {
            console.log('synStatus');
            /**
             * 同步地区的勾选状态
             */
            let pLen = 0;
            let cLen = 0;
            let bCSelected; // 国家是否被选中的标志位
            let bPSelected; // 省是否被选中的标志位
            let bRSelected;
            this.currentRegion = [];
            this.currentLocations.map((country, cIdx) => {
                // 只有国家层的情况，bCSelected表示选中了只到国家层的项
                bCSelected =
                    Object.keys(this.currentValue).indexOf(country.value) > -1 &&
                    Object.keys(this.currentValue[country.value]).length === 0;
                bCSelected && this.currentRegion.push({ value: country.value, name: country.name });

                country.subs.map((province, pIdx) => {
                    // 只有国家-省层的情况，bPSelected表示选中了只到省层的项
                    bPSelected =
                        Object.keys(this.currentValue[country.value] || {}).indexOf(province.value) > -1 &&
                        Object.keys(this.currentValue[country.value][province.value]).length === 0;
                    bPSelected && this.currentRegion.push({ value: province.value, name: province.name });
                    province.subs.map((city, rIdx) => {
                        // 国家-省-市的情况，bRSelected表示选中了到市层的项
                        bRSelected =
                            Object.keys(
                                this.currentValue[country.value]
                                    ? this.currentValue[country.value][province.value] || {}
                                    : {}
                            ).indexOf(city.value) > -1;
                        this.$set(this.selectedStatus[cIdx].province[pIdx].city[rIdx], 'checked', bRSelected);

                        bRSelected && this.currentRegion.push({ value: city.value, name: city.name });
                    });
                    cLen = this.selectedStatus[cIdx].province[pIdx].city.filter(st => st.checked).length;
                    // 省下的市没有全部被选中，置于indeterminate状态
                    this.$set(this.selectedStatus[cIdx].province[pIdx], 'indeterminate', cLen < province.subs.length);
                    // 省本身被选中或者省下有市被选中，置于checked状态
                    this.$set(this.selectedStatus[cIdx].province[pIdx], 'checked', bPSelected || cLen > 0);
                });
                // 如果不含省的话国家标志位不会被改变，包含了省的情况下
                // 国家的标志位在进入循环前一定是false
                // 省被选中的情况下才会被设置为true
                pLen = this.selectedStatus[cIdx].province.filter(st => {
                    if (st.checked) bCSelected = true; // 国家下有省被选中，将控制国家checked状态的bCSelected置为true
                    return st.checked && !st.indeterminate;
                }).length;
                // 国家下的省没有全部处于全选中状态，置于indeterminate状态
                this.$set(this.selectedStatus[cIdx], 'indeterminate', pLen < country.subs.length);
                // 国家本身被选中或者国家下有省被选中，置于checked状态
                this.$set(this.selectedStatus[cIdx], 'checked', bCSelected);
            });
            this.$emit('getCity', this.currentRegion);
        },
        getPolyInfo() {
            /**
             * 获取全选时最下一级的数据和对应的名字
             * 例如全选江苏，那么只取到江苏，后面的市就不再取了
             */
            this.currentPolyValue = [];
            this.polyRegion = [];
            let bRSelected;
            let bAllCountry;
            let bAllProvince;
            this.currentLocations.map((country, cIdx) => {
                bAllCountry = this.selectedStatus[cIdx].checked && !this.selectedStatus[cIdx].indeterminate;
                bAllCountry && this.currentPolyValue.push(country.value) && this.polyRegion.push(country.name);
                country.subs.map((province, pIdx) => {
                    if (!bAllCountry) {
                        bAllProvince =
                            this.selectedStatus[cIdx].province[pIdx].checked &&
                            !this.selectedStatus[cIdx].province[pIdx].indeterminate;
                        bAllProvince &&
                            this.currentPolyValue.push(province.value) &&
                            this.polyRegion.push(province.name);
                    }
                    province.subs.map(city => {
                        // 国家-省-市的情况，bRSelected表示选中了到市层的项
                        bRSelected =
                            Object.keys(
                                this.currentValue[country.value]
                                    ? this.currentValue[country.value][province.value] || {}
                                    : {}
                            ).indexOf(city.value) > -1;
                        if (!bAllCountry && !bAllProvince && bRSelected) {
                            this.currentPolyValue.push(city.value);
                            this.polyRegion.push(city.name);
                        }
                    });
                });
            });
            this.oldPolyValue = this.currentPolyValue.concat();
        },
        hoverCountry(country, index) {
            this.hoverCountryIndex = index;
        },
        hoverProvince(province, index) {
            this.hoverProvinceIndex = index;
        },
        hoverCity(city, index) {
            this.hoverCityIndex = index;
        },
        selectCountry(status, tar) {
            /**
             * 选择国家事件，函数里的level表示最底处的层级
             */
            let level = '';
            if (this.currentLocations[this.hoverCountryIndex].subs.length === 0) {
                level = 'country';
            } else if (this.currentLocations[this.hoverCountryIndex].subs[0].subs.length === 0) {
                level = 'province';
            } else {
                level = 'city';
            }

            this.handleCValues(status, level, tar);
        },
        selectProvince(status, tar) {
            /**
             * 选择省事件，函数里的level表示最底处的层级
             */
            let level = '';
            if (this.currentLocations[this.hoverCountryIndex].subs[this.hoverProvinceIndex].subs.length === 0) {
                level = 'province';
            } else {
                level = 'city';
            }
            this.handlePValues(status, level, tar);
        },
        selectCity(status, tar) {
            /**
             * 选择市事件。由于市是最小单位，此函数会对树结构做插入删除操作
             */
            if (status) {
                this.treeInsert(this.currentValue, tar.value);
            } else {
                this.treeRemove(this.currentValue, tar.value);
            }
            this.handleRValues(status, tar);
        },
        handleCValues(status, level, tar) {
            /**
             * 选择国家的value处理
             */
            const tempValues = JSON.parse(JSON.stringify(this.currentValue));
            this.$set(this.selectedStatus[this.hoverCountryIndex], 'checked', status);
            this.$set(this.selectedStatus[this.hoverCountryIndex], 'indeterminate', false);
            switch (level) {
                case 'country': // 最底层是国家的情况，先删去树结构中国家的值，再根据status是否插入
                    this.treeRemove(tempValues, tar.value);
                    status && this.treeInsert(tempValues, tar.value);
                    break;
                case 'province': // 最底层是省的情况，先删去树结构中该国家所有省的值，再根据status进行插入
                    this.currentLocations[this.hoverCountryIndex].subs.map((province, pIdx) => {
                        this.treeRemove(tempValues, province.value);
                    });
                    this.currentLocations[this.hoverCountryIndex].subs.map((province, pIdx) => {
                        status && this.treeInsert(tempValues, province.value);
                        this.$set(this.selectedStatus[this.hoverCountryIndex].province[pIdx], 'indeterminate', false);
                        this.$set(this.selectedStatus[this.hoverCountryIndex].province[pIdx], 'checked', status);
                    });
                    break;
                default:
                    // 最底层是市的情况，先删去树结构中该国家所有省与市的值，再根据status进行插入
                    this.currentLocations[this.hoverCountryIndex].subs.map((province, pIdx) => {
                        if (province.subs.length > 0) {
                            province.subs.map((city, cIdx) => {
                                this.treeRemove(tempValues, city.value);
                            });
                        } else {
                            // 处理一个国家大部分省都有市但个别的省没有市的特殊情况
                            this.treeRemove(tempValues, province.value);
                        }
                    });
                    this.currentLocations[this.hoverCountryIndex].subs.map((province, pIdx) => {
                        this.$set(this.selectedStatus[this.hoverCountryIndex].province[pIdx], 'indeterminate', false);
                        this.$set(this.selectedStatus[this.hoverCountryIndex].province[pIdx], 'checked', status);
                        if (province.subs.length) {
                            province.subs.map((city, cIdx) => {
                                status && this.treeInsert(tempValues, city.value);
                                this.$set(
                                    this.selectedStatus[this.hoverCountryIndex].province[pIdx].city[cIdx],
                                    'indeterminate',
                                    false
                                );
                                this.$set(
                                    this.selectedStatus[this.hoverCountryIndex].province[pIdx].city[cIdx],
                                    'checked',
                                    status
                                );
                            });
                        } else {
                            // 处理一个国家大部分省都有市但个别的省没有市的特殊情况
                            status && this.treeInsert(tempValues, province.value);
                        }
                    });
            }
            this.currentValue = JSON.parse(JSON.stringify(tempValues));
        },
        handlePValues(status, level, tar) {
            /**
             * 选择省的value处理
             */
            const tempValues = JSON.parse(JSON.stringify(this.currentValue));
            let selectedLength;
            let totalLength;
            let bCSelected = false;

            this.$set(
                this.selectedStatus[this.hoverCountryIndex].province[this.hoverProvinceIndex],
                'indeterminate',
                false
            );
            this.$set(this.selectedStatus[this.hoverCountryIndex].province[this.hoverProvinceIndex], 'checked', status);
            selectedLength = this.selectedStatus[this.hoverCountryIndex].province.filter(st => {
                if (st.checked) bCSelected = true; // 国家下有省被选中，将控制国家checked状态的bCSelected置为true
                return st.checked && !st.indeterminate;
            }).length;
            totalLength = this.currentLocations[this.hoverCountryIndex].subs.length;
            this.$set(this.selectedStatus[this.hoverCountryIndex], 'checked', bCSelected);
            this.$set(this.selectedStatus[this.hoverCountryIndex], 'indeterminate', selectedLength < totalLength);

            switch (level) {
                case 'province': // 最底层是省的情况，先删去树结构中该国家所有省的值，再根据status进行插入
                    this.treeRemove(tempValues, tar.value);
                    status && this.treeInsert(tempValues, tar.value);
                    break;
                default:
                    // 最底层是市的情况，先删去树结构中该国家所有省与市的值，再根据status进行插入
                    this.currentLocations[this.hoverCountryIndex].subs[this.hoverProvinceIndex].subs.map(city => {
                        this.treeRemove(tempValues, city.value);
                    });

                    this.currentLocations[this.hoverCountryIndex].subs[this.hoverProvinceIndex].subs.map(
                        (city, cIdx) => {
                            status && this.treeInsert(tempValues, city.value);
                            this.$set(
                                this.selectedStatus[this.hoverCountryIndex].province[this.hoverProvinceIndex].city[
                                    cIdx
                                ],
                                'indeterminate',
                                false
                            );
                            this.$set(
                                this.selectedStatus[this.hoverCountryIndex].province[this.hoverProvinceIndex].city[
                                    cIdx
                                ],
                                'checked',
                                status
                            );
                        }
                    );
            }
            this.currentValue = JSON.parse(JSON.stringify(tempValues));
        },
        handleRValues(status, tar) {
            /**
             * 选择市的value处理
             */
            let tempSelectProvince = [];
            let selectedCityLength;
            let totalCityLength;
            let selectedProvinceLength;
            let fullSelectedProvinceLength;
            let totalProvinceLength;

            selectedCityLength = this.selectedStatus[this.hoverCountryIndex].province[
                this.hoverProvinceIndex
            ].city.filter(st => st.checked).length;
            totalCityLength = this.currentLocations[this.hoverCountryIndex].subs[this.hoverProvinceIndex].subs.length;
            this.$set(
                this.selectedStatus[this.hoverCountryIndex].province[this.hoverProvinceIndex],
                'indeterminate',
                selectedCityLength < totalCityLength
            );
            this.$set(
                this.selectedStatus[this.hoverCountryIndex].province[this.hoverProvinceIndex],
                'checked',
                !!selectedCityLength
            );

            tempSelectProvince = this.selectedStatus[this.hoverCountryIndex].province.filter(st => st.checked);
            selectedProvinceLength = tempSelectProvince.length;
            fullSelectedProvinceLength = tempSelectProvince.filter(st => !st.indeterminate).length;
            totalProvinceLength = this.currentLocations[this.hoverCountryIndex].subs.length;
            this.$set(this.selectedStatus[this.hoverCountryIndex], 'checked', !!selectedProvinceLength);
            this.$set(
                this.selectedStatus[this.hoverCountryIndex],
                'indeterminate',
                fullSelectedProvinceLength < totalProvinceLength
            );
            this.currentValue = JSON.parse(JSON.stringify(this.currentValue)); // 用于触发currentValue变化事件
        },
        getRegionNames() {
            /**
             * 对region的更新，region数据外部会用到。
             */
            this.currentRegion = [];
            this.currentPolyValue = [];
            this.polyRegion = [];
            let bAllCountry;
            let bAllProvince;
            let bCSelected;
            let bPSelected;
            let bRSelected;
            this.currentLocations.map((country, cIdx) => {
                // 只有国家层的情况，bCSelected表示选中了只到国家层的项
                bCSelected =
                    Object.keys(this.currentValue).indexOf(country.value) > -1 &&
                    Object.keys(this.currentValue[country.value]).length === 0;
                bCSelected && this.currentRegion.push({ value: country.value, name: country.name });

                bAllCountry = this.selectedStatus[cIdx].checked && !this.selectedStatus[cIdx].indeterminate;
                bAllCountry && this.currentPolyValue.push(country.value) && this.polyRegion.push(country.name);
                country.subs.map((province, pIdx) => {
                    // 只有国家-省层的情况，bPSelected表示选中了只到省层的项
                    bPSelected =
                        Object.keys(this.currentValue[country.value] || {}).indexOf(province.value) > -1 &&
                        Object.keys(this.currentValue[country.value][province.value]).length === 0;
                    bPSelected && this.currentRegion.push({ value: province.value, name: province.name });
                    if (!bAllCountry) {
                        bAllProvince =
                            this.selectedStatus[cIdx].province[pIdx].checked &&
                            !this.selectedStatus[cIdx].province[pIdx].indeterminate;
                        bAllProvince &&
                            this.currentPolyValue.push(province.value) &&
                            this.polyRegion.push(province.name);
                    }
                    province.subs.map(city => {
                        // 国家-省-市的情况，bRSelected表示选中了到市层的项
                        bRSelected =
                            Object.keys(
                                this.currentValue[country.value]
                                    ? this.currentValue[country.value][province.value] || {}
                                    : {}
                            ).indexOf(city.value) > -1;
                        bRSelected && this.currentRegion.push({ value: city.value, name: city.name });
                        if (!bAllCountry && !bAllProvince && bRSelected) {
                            this.currentPolyValue.push(city.value);
                            this.polyRegion.push(city.name);
                        }
                    });
                });
            });
        },
        handleSelectAll() {
            /**
             * 全选事件。遍历location对树结构进行插入
             */
            this.currentValue = {};
            this.currentPolyValue = [];
            this.polyRegion = [];
            this.currentLocations.map((country, cIdx) => {
                if (country.subs.length === 0) {
                    this.treeInsert(this.currentValue, country.value);
                }
                this.currentPolyValue.push(country.value) && this.polyRegion.push(country.name);
                this.$set(this.selectedStatus[cIdx], 'checked', true);
                this.$set(this.selectedStatus[cIdx], 'indeterminate', false);
                country.subs.map((province, pIdx) => {
                    if (province.subs.length === 0) {
                        this.treeInsert(this.currentValue, province.value);
                    }
                    this.$set(this.selectedStatus[cIdx].province[pIdx], 'indeterminate', false);
                    this.$set(this.selectedStatus[cIdx].province[pIdx], 'checked', true);
                    province.subs.map((city, rIdx) => {
                        this.treeInsert(this.currentValue, city.value);
                        this.$set(this.selectedStatus[cIdx].province[pIdx].city[rIdx], 'indeterminate', false);
                        this.$set(this.selectedStatus[cIdx].province[pIdx].city[rIdx], 'checked', true);
                    });
                });
            });
        },
        handleClearAll() {
            console.log('handleClearAll');
            /**
             * 清空事件
             */
            this.currentValue = {};
            this.currentPolyValue = [];
            this.synStatus();
        },
        handleConfirm(e) {
            console.log('handleConfirm');
            /**
             * 确认事件。此处需将currentRegion的地区信息进行更新，并把value等信息进行调用透传。
             */
            this.getRegionNames();
            const val = this.treeToVal(this.currentValue);
            this.$emit('input', val);
            const res = this.polymerization ? this.currentPolyValue.map(item => item.split('@')) : val;
            this.$emit('change', res);

            this.$emit(
                'getCity',
                this.currentRegion,
                this.polymerization
                    ? this.polyRegion.map((name, idx) => {
                          return {
                              name,
                              value: this.currentPolyValue[idx].split('@')
                          };
                      })
                    : null
            );
            this.oldValue = JSON.parse(JSON.stringify(this.currentValue));
            this.oldPolyValue = this.currentPolyValue.concat();
        },
        handleCancel() {
            console.log('handleCancel')
            /**
             * 取消事件
             */
            this.currentValue = JSON.parse(JSON.stringify(this.oldValue));
            this.currentPolyValue = this.oldPolyValue.concat();
            // 还原状态
            this.synStatus();
        },
        handleVisibleChange(visible) {
            /**
             * 用于懒加载，当窗口出现之后再把startRender置为true开始加载
             */
            if (visible) this.startRender = true;
        },
        createValueTree(val) {
            /**
             * 将currentValue保存为tree结构，传入的val是展平的结构，该函数将展平结构生成为树状结构，按照country-province-city的层次排列，
             * 其中province和city层的key都是和location数据一样的带@符号的复式结构。当一个节点是叶节点时，代表它是选项的最底层。
             */
            const currentValue = {};
            val.forEach(item => {
                let node = currentValue;
                const vList = [];
                item.forEach(v => {
                    vList.push(v);
                    const key = vList.join('@');
                    if (!node[key]) node[key] = {};
                    node = node[key];
                });
            });
            return currentValue;
        },
        treeToVal(tree) {
            /**
             * 将tree结构展平为一维数组结构，该函数为createValueTree的反函数
             */
            const val = [];
            Object.keys(tree).forEach(key => {
                if (Object.keys(tree[key]).length > 0) {
                    const res = this.treeToVal(tree[key]);
                    res.forEach(v => {
                        const kList = key.split('@');
                        v.unshift(kList[kList.length - 1]);
                        val.push(v);
                    });
                } else {
                    const kList = key.split('@');
                    val.push([kList[kList.length - 1]]);
                }
            });
            return val;
        },
        treeInsert(tree, value) {
            /**
             * 在树结构中插入一个值，若在空位置插入，则会逐级生成节点。例如对空树{}插入country-province-city的值，
             * 会依次生成country-province-city三层节点。
             */
            let vList = value.split('@');
            const tmp = [];
            vList = vList.map(v => {
                tmp.push(v);
                return tmp.join('@');
            });
            let node = tree;
            vList.forEach(v => {
                if (!node[v]) node[v] = {};
                node = node[v];
            });
        },
        treeRemove(tree, value) {
            /**
             * 在树结构中删除一个值，若删除节点后其父节点不存在其他子节点，则会逐级删除节点。
             * 例如对树{country-province-city}删除值country-province-city，则会依次删除节点最后得到空树{}。
             */
            let vList = value.split('@');
            const tmp = [];
            vList = vList.map(v => {
                tmp.push(v);
                return tmp.join('@');
            });
            let node = tree;
            for (const v of vList) {
                if (!node[v]) return;
                node = node[v];
            }
            if (vList[2]) delete tree[vList[0]][vList[1]][vList[2]];
            if (vList[1] && Object.keys(tree[vList[0]][vList[1]]).length === 0) {
                delete tree[vList[0]][vList[1]];
            }
            if (vList[0] && Object.keys(tree[vList[0]]).length === 0) {
                delete tree[vList[0]];
            }
        }
    }
};
</script>

<style lang="less">
.components-filter-view-config-region-select-container {
    position: relative;
    display: inline-block;
    padding: 0 10px 0 12px;
    width: 200px;
    height: 40px;
    color: #1e2330;
    border: 1px solid #dadee7;
    box-sizing: border-box;
    cursor: pointer;
    vertical-align: top;
    line-height: 40px;

    &-check-all {
        min-height: 39px;
        border-bottom: 1px solid #dadee7;

        .v-checkbox {
            padding: 10px 0 10px 12px;
            width: 100%;
            box-sizing: border-box;
        }
    }

    .select-icon {
        position: absolute;
        top: 15px;
        right: 10px;
        width: 10px;
        height: 10px;
        color: #a8abb3;
    }

    &:hover {
        border-color: #a8bbb3;
    }

    &-header {
        position: relative;
        overflow: hidden;
        padding: 0 10px 0 12px;
        min-width: 50px;
        font-size: 14px;
        text-align: left;
        background-color: #fff;
        border: 1px solid #dadee7;
        border-radius: 2px;
        transition: border-color 0.25s, background-color 0.25s;
        line-height: 38px;
        cursor: pointer;

        &:hover {
            border-color: #a8abb3;
        }

        &:active {
            background-color: #ebedf2;
            border-color: #a8abb3;
        }

        &-arrow {
            &.v-icon {
                position: absolute;
                top: 15px;
                right: 10px;
                width: 10px;
                height: 10px;
                cursor: pointer;
                stroke: #a8abb3;
            }
        }
    }

    &-popup {
        margin-top: 5px;
        background-color: #fff;
        border: 1px solid rgba(0, 0, 0, 0.15);
        border-radius: 4px;
        z-index: 200;
        box-shadow: 0 0 8px 5px rgba(61, 64, 74, 0.08);
        box-sizing: border-box;
    }

    &-container {
        position: relative;
        width: 496px;
        height: 290px;
        border: 1px solid #dadee7;
        border-radius: 2px;

        /* box-sizing: border-box; */
        margin-bottom: 15px;

        ul::-webkit-scrollbar {
            width: 6px;
            height: 8px;
        }

        ul::-webkit-scrollbar-thumb {
            background-color: #c8cbcc;
            border-radius: 8px;
        }

        .batch-operation-container {
            position: absolute;
            bottom: -45px;
            color: #0067ed;
            cursor: pointer;

            .batch-unselect {
                margin-left: 10px;
            }
        }

        .location-select-list-new {
            position: absolute;
            top: 0;
            display: inline-block;
            overflow-x: hidden;
            overflow-y: scroll;
            margin: 0;
            padding: 0;
            width: 165px;
            height: 290px;
            border-right: 1px solid #dadee7;
            box-sizing: border-box;

            &.country {
                left: 0;
            }

            &.province {
                left: 166px;

                &.no-country {
                    left: 0;
                }
            }

            &.city {
                left: 332px;

                &.no-country {
                    left: 166px;
                }
            }

            &:last-child {
                float: right;
                border-right: none;
            }

            .v-checkbox {
                padding-left: 10px;
                width: 100%;
                height: 36px;
                line-height: 36px;
                vertical-align: middle;

                &:hover {
                    background-color: #f5fafe;
                }

                .v-checkbox__icon {
                    margin-top: 8px;
                }
            }

            .location-arrow-icon {
                float: right;
                margin-top: -23px;
                margin-right: 5px;
                width: 10px;
                height: 10px;
                stroke: #a8abb3;
            }

            .hover-province {
                background-color: #f5fafe; //d3e9ff
            }

            .checkbox-content {
                overflow: hidden;
                padding-right: 30px;
                width: 100%;
                text-overflow: ellipsis;
                white-space: nowrap;
            }

            /* &:first-child{ */

            /* border-right: 1px solid #ccc; */

            /* } */
        }
    }

    &-unknown-wrap {
        height: 371px;
    }
}

.popper-filter-view-config-region-select-container {
    margin-top: 4px;
    margin-left: -14px;

    .location-select-new-container {
        position: relative;
        width: 496px;
        height: 290px;
        border: 1px solid #dadee7;
        border-radius: 2px;
        margin-bottom: 15px;

        ul::-webkit-scrollbar {
            width: 6px;
            height: 8px;
        }

        ul::-webkit-scrollbar-thumb {
            background-color: #c8cbcc;
            border-radius: 8px;
        }

        .batch-operation-container{
            position: absolute;
            bottom: -45px;
            color: #0067ed;
            cursor: pointer;

            .batch-unselect{
                margin-left: 10px;
            }
        }

        .location-select-list-new {
            position: absolute;
            top: 0;
            display: inline-block;
            overflow-x: hidden;
            overflow-y: scroll;
            margin: 0;
            padding: 0;
            width: 165px;
            height: 290px;
            border-right: 1px solid #dadee7;
            box-sizing: border-box;

            &.country{
                left: 0;
            }

            &.province{
                left: 166px;

                &.no-country{
                    left: 0;
                }
            }

            &.city{
                left: 332px;

                &.no-country{
                    left: 166px;
                }
            }

            &:last-child{
                float:right;
                border-right: none;
            }

            .v-checkbox {
                padding-left: 10px;
                width: 100%;
                height: 36px;
                line-height: 36px;
                vertical-align: middle;

                &:hover{
                    background-color: #f5fafe;
                }

                .v-checkbox__icon {
                    margin-top: 8px;
                }

            }

            .location-arrow-icon {
                float:right;
                margin-top: -23px;
                margin-right: 5px;
                width: 10px;
                height: 10px;
                stroke: #a8abb3;
            }

            .hover-province {
                background-color: #f5fafe;
            }

            .checkbox-content {
                overflow: hidden;
                padding-right: 30px;
                width: 100%;
                text-overflow: ellipsis;
                white-space: nowrap;
            }
        }
    }
}
</style>
